import { format } from "date-fns";
import { FOURTH_TRIMESTER_DATES, FOURTH_TRIMESTER_TIME_SLOTS } from "@/data/site";

export const CourseDates = () => (
  <div className="mt-3" data-testid="course-dates">
    <p className="text-sm text-cocoa">
      Six Sundays · {FOURTH_TRIMESTER_TIME_SLOTS[0]} (some classes may extend to 6:00 PM)
    </p>
    <ol className="mt-3 grid grid-cols-1 gap-2 sm:grid-cols-2">
      {FOURTH_TRIMESTER_DATES.map((d, i) => (
        <li key={d} className="flex items-baseline gap-3 text-sm text-espresso" data-testid={`course-date-${i + 1}`}>
          <span className="font-serif italic text-sienna">Week {i + 1}</span>
          {format(new Date(d + "T00:00:00"), "EEEE, MMMM d, yyyy")}
        </li>
      ))}
    </ol>
  </div>
);
